/* js/tabs.js */

'use strict'; 

;(function($, window, document) {
   
   var $tabList; 
   var tabListOuterWidth = 0;
   
   $(window).on('load', function() {
        $tabList = $('.mod_articlelist ul li');
        $('.mod_article.b-tab').addClass('is--large');
        $('.mod_articlelist').addClass('is--large');
        $tabList.each(function(i, e){
            tabListOuterWidth += $(e).outerWidth();
        });
        
   });
   
    $(window).on('resize', function() {
        
        //calculate the padding and width for the tabList and the tabArticles to add and remove classes
        var tabArticleWidth = $('.mod_article.b-tab').outerWidth();
        
        if (tabArticleWidth <= tabListOuterWidth) {
            $('.mod_articlelist').addClass('is--small');
            $('.mod_articlelist').removeClass('is--large');
            $('.mod_article.b-tab').removeClass('is--large');
        } else {
            $('.mod_articlelist').removeClass('is--small');
            $('.mod_articlelist').addClass('is--large');
            $('.mod_article.b-tab').addClass('is--large');
        }

    });
    
    
    
    $(document).ready(function () {

        //add and remove class is--open to tab-list for mobile
        $('.mod_articlelist').on('click', function () {
           $(this).toggleClass('is--open'); 
        });
        
        
        //activate the first tab-list-element
        var firstActive = function() {
          $('.mod_articlelist ul li:first-child a').addClass('active');
        }
          
        firstActive();
        
        
        function Tabs() {
        
          var bindAll = function() {
            var menuElements = document.querySelectorAll('[data-tab]');
            for(var i = 0; i < menuElements.length ; i++) {
              menuElements[i].addEventListener('click', change, false);
            }
          }
        
          var clear = function() {
            var menuElements = document.querySelectorAll('[data-tab]');
            for(var i = 0; i < menuElements.length ; i++) {
              menuElements[i].classList.remove('active');
              var id = menuElements[i].getAttribute('data-tab');
              document.getElementById(id).classList.remove('active');
            }
          }
        
          var change = function(e) {
            clear();
            e.target.classList.add('active');
            var id = e.currentTarget.getAttribute('data-tab');
            document.getElementById(id).classList.add('active');
          }
          
          bindAll();
        }
        
        var connectTabs = new Tabs();
        
    });

})(jQuery, window, document);